//#region import
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Chip, Divider, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { ProjectContext } from '../ProjectRequestFrom';
import { BtnExample, BtnSend } from 'components/Button/ButtonAll';
import { Convert, Extension, FnAxios, FnDialog, I18n, ParseHtml, formatNumber } from 'utilities/utilities';
import { APIStatusCode, EnumProjectStatusFinalScore, EnumProjectStatusID, EnumSaveModeProject, I18NextNs } from 'enum/enum';
import { useLocation, useNavigate } from 'react-router';
import { FormProvider, useForm } from 'react-hook-form';
import { ApiProject } from 'enum/api';
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, styled } from '@mui/material';
import { parseFloatCheckValue } from 'view/Backend/IncomeExpenses/Ticket/fnTickit';
import { TextAreaItem } from 'components/Input/TextArea';
import { List as LINQ } from "linqts";
import _ from "lodash";
import moment from 'moment';
import ContentWrapper from '../components/ContentWrapper';
import { SelectItem } from 'components/Input/Select/SelectItem';
import InputNumberItem from 'components/Input/InputNumber';
import PDFIcon from "../../../../assets/images/DocTypeIcon/PDF.svg";
import { TextBoxItem } from 'components/Input/TextBox';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import { CheckBoxItem } from 'components/Input/Checkbox/CheckBoxItem';
import UploadFileItem from 'components/Input/UploadFile';
import ErrorIcon from '@mui/icons-material/Error';
//#endregion

const ProjectResultLetter = () => { //บันทึกมติจากคณะกรรมการบริหาร
    const {
        nProjectID,
        isFastTrack,
        isPermission,
        nStatusID,
        sMode,
        sTabID,
    } = useContext(ProjectContext);

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();
    const navigate = useNavigate();

    //#region useState
    const [arrProjectStatusID, setarrProjectStatusID] = useState([]); //ข้อมูลสถานะโครงการ
    const [arrDataUserID, setarrDataUserID] = useState([]); //ข้อมูลคนของ เจ้าหน้าที่กองคุ้มครองซากดึกดำบรรพ์

    const [ObjDataProject, setObjDataProject] = useState(null); //ข้อมูลสถานะโครงการ CDataProjectResultLetter ?
    const [ObjDataFile, setObjDataFile] = useState(null); //ไฟล์ที่จะ Gen PDF << ResultExampleFile ? 
    const [isExternal, setisExternal] = useState(false); //True = ภายนอก | False = ภายใน << TbProject : nUnitTypeID ประเภทหน่วยงาน TmMasterData nMasterTypeID = 16 กรณีที่เลือกเป็น กรมทรัพยากรธรณี จะมองเป็นโครงการภายใน
    const [nMeetingResolutionID, setnMeetingResolutionID] = useState(null); //มติที่ประชุม (อนุมัติโครงการ | ไม่อนุมัติโครงการ) << int? nStatusID
    const [nTotalWeightScore, setnTotalWeightScore] = useState(null); //ผลคะแนนรวมที่ได้ (คิดค่าน้ำหนัก) จะเก็บลง TbProject ตอน FastTrack = True เร่งด่วน << decimal ?
    const [ObjResultLetter, setObjResultLetter] = useState(null); //ข้อมูล ผ่าน/ไม่ผ่าน : ภายใน/ภายนอก << CResultLetter ?

    const [isStatusPass, setisStatusPass] = useState(null);
    const onClearFile = useRef(null);
    const [arrFileDocument, setarrFileDocument] = useState([]);
    const [isEdit, setisEdit] = useState(nStatusID === EnumProjectStatusID.nStatusID_10 ? isPermission : false);

    const onClearFilePDF = useRef(null);
    const [arrFileDocumentPDF, setarrFileDocumentPDF] = useState([]);

    const onClearFileContractPDF = useRef(null);
    const [arrFileDocumentContractPDF, setarrFileDocumentContractPDF] = useState([]);
    //#endregion

    useEffect(() => {
        if (nProjectID !== 0) GetFormProjectResultLetter();
    }, [nProjectID]);

    useEffect(() => {
        if (nStatusID) setisEdit(nStatusID === EnumProjectStatusID.nStatusID_10 ? isPermission : false);
    }, [isPermission, nStatusID]);

    const GetFormProjectResultLetter = () => {
        AxiosFn.Get(ApiProject.GetFormProjectResultLetter, { nProjectID: nProjectID }, (result) => {
            //result.nProjectID
            //result.isFastTrack //True = เร่งด่วน | False = ปกติ
            setarrProjectStatusID(result.lstProjectStatusID); //ข้อมูลสถานะโครงการ
            setarrDataUserID(result.lstDataUserID); //ข้อมูลคนของ เจ้าหน้าที่กองคุ้มครองซากดึกดำบรรพ์

            setObjDataProject(result.ObjDataProject); //ข้อมูลสถานะโครงการ CDataProjectResultLetter ?
            setObjDataFile(result.ObjDataFile); //ไฟล์ที่จะ Gen PDF << ResultExampleFile ? 
            setisExternal(result.isExternal); //True = ภายนอก | False = ภายใน << TbProject : nUnitTypeID ประเภทหน่วยงาน TmMasterData nMasterTypeID = 16 กรณีที่เลือกเป็น กรมทรัพยากรธรณี จะมองเป็นโครงการภายใน
            setnMeetingResolutionID(result.nMeetingResolutionID); //มติที่ประชุม (อนุมัติโครงการ | ไม่อนุมัติโครงการ) << int?
            form.setValue("nMeetingResolutionID", result.nMeetingResolutionID); //มติที่ประชุม (อนุมัติโครงการ | ไม่อนุมัติโครงการ)
            if (result.nMeetingResolutionID !== null) setisStatusPass(result.nMeetingResolutionID === 11 ? true : false);
            setnTotalWeightScore(result.nTotalWeightScore); //ผลคะแนนรวมที่ได้ (คิดค่าน้ำหนัก) จะเก็บลง TbProject ตอน FastTrack = True เร่งด่วน << decimal ?
            setObjResultLetter(result.ObjResultLetter); //ข้อมูล ผ่าน/ไม่ผ่าน : ภายใน/ภายนอก << CResultLetter ?
            setarrFileDocumentPDF(result.lstFileDocumentPDF); //ไฟล์หนังสือแจ้งผลการพิจารณา
            setarrFileDocumentContractPDF(result.lstFileDocumentContractPDF); //ไฟล์เอกสารสัญญา
        });
    }

    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            nMeetingResolutionID: null, //มติที่ประชุม (อนุมัติโครงการ | ไม่อนุมัติโครงการ)
            // nTotalWeightScore: null, //ผลคะแนนรวมที่ได้ (คิดค่าน้ำหนัก) จะเก็บตอน FastTrack = True เร่งด่วน
            //ข้อมูล ผ่าน/ไม่ผ่าน : ภายใน/ภายนอก << CResultLetter? ObjResultLetter
            nProjectScore: null, //ผลคะแนนรวมที่ได้ (คิดค่าน้ำหนัก) จะเก็บตอน FastTrack = True เร่งด่วน
            sFundDocNo: null, //เลขที่เอกสาร   
            dFundDoc: null, //วันที่เอกสาร
            // nDateFundDoc: null, //วันที่เอกสาร
            sDocTo: null, //เรียน
            sDocRef: null, //ตามหนังสือ/อ้างถึง 
            sDocNo: null, //ที่
            dDoc: null, //ลงวันที่
            // nDateDoc: null, //ลงวันที่
            sDocProjectName: null, //ชื่อโครงการตามหนังสือ
            sBy: null, //โดย
            isCommittee: "Y", //คณะกรรมการบริหารกองทุนจัดการซากดึกดำบรรพ์
            sMeetingNo: null, //ประชุมครั้งที่
            dMeeting: null, //เมื่อวันที่
            // nDateMeeting: null, //เมื่อวันที่
            dInvoice: null, //เอกสารการขอเบิกเงินยื่นต่อฝ่ายเลขานุการคณะกรรมการบริหารกองทุนฯ ภายในวันที่ | ดำเนินการขอเบิกจ่ายเงิน ภายในวันที่
            // nDateInvoice: null, //เอกสารการขอเบิกเงินยื่นต่อฝ่ายเลขานุการคณะกรรมการบริหารกองทุนฯ ภายในวันที่ | ดำเนินการขอเบิกจ่ายเงิน ภายในวันที่
            nCoordinatorID: null, //มอบหมายให้ (ผู้ประสานงาน) TbUser
            sCoordinatorPosition: null, //ตำแหน่งทางวิชาการ
            sCoordinatorTel: null, //หมายเลขโทรศัพท์
            sReason: null, //หมายเหตุ/เหตุผล
            // lstFileDocument: null, //ไฟล์ทั้งหมด
        } as any,
    });

    useEffect(() => {
        //ข้อมูล ผ่าน/ไม่ผ่าน : ภายใน/ภายนอก << CResultLetter? ObjResultLetter
        if (ObjResultLetter != null) {
            form.setValue("nProjectScore", ObjResultLetter.nProjectScore); //ผลคะแนนรวมที่ได้ (คิดค่าน้ำหนัก) จะเก็บตอน FastTrack = True เร่งด่วน
            form.setValue("sFundDocNo", ObjResultLetter.sFundDocNo); //เลขที่เอกสาร   
            form.setValue("dFundDoc", moment(ObjResultLetter.nDateFundDoc)); //ObjResultLetter.dFundDoc, //วันที่เอกสาร
            form.setValue("sDocTo", ObjResultLetter.sDocTo); //เรียน
            form.setValue("sDocRef", ObjResultLetter.sDocRef); //ตามหนังสือ/อ้างถึง 
            form.setValue("sDocNo", ObjResultLetter.sDocNo); //ที่
            form.setValue("dDoc", moment(ObjResultLetter.nDateDoc)); //ลงวันที่
            form.setValue("sDocProjectName", ObjResultLetter.sDocProjectName); //ชื่อโครงการตามหนังสือ
            form.setValue("sBy", ObjResultLetter.sBy); //โดย
            form.setValue("isCommittee", "Y"); //true, //คณะกรรมการบริหารกองทุนจัดการซากดึกดำบรรพ์
            form.setValue("sMeetingNo", ObjResultLetter.sMeetingNo); //ประชุมครั้งที่
            form.setValue("dMeeting", moment(ObjResultLetter.nDateMeeting)); //ObjResultLetter.dMeeting, //เมื่อวันที่
            form.setValue("dInvoice", moment(ObjResultLetter.nDateInvoice)); //ObjResultLetter.dInvoice, //เอกสารการขอเบิกเงินยื่นต่อฝ่ายเลขานุการคณะกรรมการบริหารกองทุนฯ ภายในวันที่ | ดำเนินการขอเบิกจ่ายเงิน ภายในวันที่
            form.setValue("nCoordinatorID", ObjResultLetter.nCoordinatorID); //มอบหมายให้ (ผู้ประสานงาน) TbUser
            form.setValue("sCoordinatorPosition", ObjResultLetter.sCoordinatorPosition); //ตำแหน่งทางวิชาการ
            form.setValue("sCoordinatorTel", ObjResultLetter.sCoordinatorTel); //หมายเลขโทรศัพท์
            form.setValue("sReason", ObjResultLetter.sReason); //หมายเหตุ/เหตุผล
            setarrFileDocument(ObjResultLetter.lstFileDocument ?? []); //ไฟล์ทั้งหมด
        }
    }, [ObjResultLetter]);


    const onExampleFilePDF = () => {
        // โหลดไฟล์เปิดมาอีกแท็บ
        if (ObjDataFile?.sPathFile && ObjDataFile?.sFileName) {
            window.open(ObjDataFile?.sPathFile, "_blank", 'noopener,noreferrer');
        }
    }

    const onDownloadGenPDF = async (isSave) => {
        DialogFn.BlockUI();
        let param = {
            nProjectID: nProjectID,
            isSave: isSave,
        }
        if (isSave) //แค่บันทึกไฟล์ไม่ต้อง Download PDF
        {
            await AxiosFn.Post(ApiProject.SavePDFProject, param, async (result) => {
                DialogFn.UnBlockUI();
            });
        }
        else //แค่ Download Gen PDF ไม่ต้องบันทึกไฟล์
        {
            let sProjectName = "หนังสือแจ้งผล" + (isStatusPass ? "_ผ่าน" : "_ไม่ผ่าน") + (isExternal ? "_ภายนอก" : "_ภายใน");
            let nYearThai = parseInt(moment().format('YYYY')) + 543;
            // let sFileName = sProjectName + `_${moment().format('DMMM')}${nYearThai}.pdf`;
            let sFileName = sProjectName + `_${moment().format('DMMM')}${nYearThai}.docx`;
            await AxiosFn.DowloadFileBlob(ApiProject.ExportGenPDFProject, param, sFileName, (result) => {
                DialogFn.UnBlockUI();
            });
        }
    }

    const handleSubmit = (nModeID: EnumSaveModeProject, nStatusID: EnumProjectStatusID, sMessage: string) => {
        if ((arrFileDocumentPDF || []).filter(f => !f.isDelete).length === 0 && nModeID === EnumSaveModeProject.Submit) {
            return DialogFn.Warning("กรุณาอัพโหลดไฟล์ หนังสือแจ้งผลการพิจารณา");
        }

        //// if ((arrFileDocumentContractPDF || []).filter(f => !f.isDelete).length === 0 && nModeID === EnumSaveModeProject.Submit) {
        ////     return DialogFn.Warning("กรุณาอัพโหลดไฟล์ เอกสารสัญญา");
        //// }

        let ObjForm = form.getValues();
        //ข้อมูล ผ่าน/ไม่ผ่าน | ภายใน/ภายนอก << CResultLetter? ObjResultLetter
        let _ObjResultLetter = {
            nProjectScore: Convert.StringToFloatOrNull(ObjForm.nProjectScore), //ผลคะแนนรวมที่ได้ (คิดค่าน้ำหนัก) จะเก็บตอน FastTrack = True เร่งด่วน
            sFundDocNo: ObjForm.sFundDocNo, //เลขที่เอกสาร   
            nDateFundDoc: ObjForm.dFundDoc ? ObjForm.dFundDoc.valueOf() : null, //วันที่เอกสาร
            sDocTo: ObjForm.sDocTo, //เรียน
            sDocRef: ObjForm.sDocRef, //ตามหนังสือ/อ้างถึง 
            sDocNo: ObjForm.sDocNo, //ที่
            nDateDoc: ObjForm.dDoc ? ObjForm.dDoc.valueOf() : null, //ลงวันที่
            sDocProjectName: ObjForm.sDocProjectName, //ชื่อโครงการตามหนังสือ
            sBy: ObjForm.sBy, //โดย
            isCommittee: true, //คณะกรรมการบริหารกองทุนจัดการซากดึกดำบรรพ์
            sMeetingNo: ObjForm.sMeetingNo, //ประชุมครั้งที่
            nDateMeeting: ObjForm.dMeeting ? ObjForm.dMeeting.valueOf() : null, //เมื่อวันที่
            nDateInvoice: ObjForm.dInvoice ? ObjForm.dInvoice.valueOf() : null, //เอกสารการขอเบิกเงินยื่นต่อฝ่ายเลขานุการคณะกรรมการบริหารกองทุนฯ ภายในวันที่ | ดำเนินการขอเบิกจ่ายเงิน ภายในวันที่
            nCoordinatorID: Convert.StringToIntOrNull(ObjForm.nCoordinatorID), //มอบหมายให้ (ผู้ประสานงาน) TbUser
            sCoordinatorPosition: ObjForm.sCoordinatorPosition, //ตำแหน่งทางวิชาการ
            sCoordinatorTel: ObjForm.sCoordinatorTel, //หมายเลขโทรศัพท์
            sReason: ObjForm.sReason, //หมายเหตุ/เหตุผล
            lstFileDocument: arrFileDocument, //ไฟล์ทั้งหมด
        }

        let param = {
            nProjectID: nProjectID,
            isFastTrack: isFastTrack,
            sLocation: location.pathname,
            nSaveModeProject: nModeID,
            nStatusID: nStatusID,
            nMeetingResolutionID: Convert.StringToInt(ObjForm.nMeetingResolutionID), //มติที่ประชุม (อนุมัติโครงการ | ไม่อนุมัติโครงการ)
            ObjDataProject: ObjDataProject, //CDataProjectResultLetter?
            ObjDataFile: ObjDataFile, //ไฟล์ที่จะ Gen PDF << ResultExampleFile?
            isExternal: isExternal, //True = ภายนอก | False = ภายใน 
            nTotalWeightScore: nTotalWeightScore, //ผลคะแนนรวมที่ได้ (คิดค่าน้ำหนัก) จะเก็บตอน FastTrack = True เร่งด่วน
            ObjResultLetter: _ObjResultLetter, //ข้อมูล ผ่าน/ไม่ผ่าน : ภายใน/ภายนอก << CResultLetter?
            lstFileDocumentPDF: arrFileDocumentPDF, //ไฟล์หนังสือแจ้งผลการพิจารณา
            lstFileDocumentContractPDF: arrFileDocumentContractPDF, //ไฟล์เอกสารสัญญา            
        };
        DialogFn.Submit(("คุณต้องการ" + sMessage + "หรือไม่ ?"), () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.SaveProjectResultLetter, param, async (result) => {
                // await onDownloadGenPDF(nModeID === EnumSaveModeProject.Submit); //เปลี่ยนวิธีบันทึกไฟล์ใหม่ ให้เขาอัพมาเองไม่ต้องมีให้บันทึกให้ตอนกดบันทึกยันยืน
                if (nModeID === EnumSaveModeProject.Draft) await onDownloadGenPDF(false);
                if (result.nStatusCode === APIStatusCode.Success) {
                    DialogFn.UnBlockUI();
                    DialogFn.Success((sMessage + "สำเร็จ"), () => { if (nModeID === EnumSaveModeProject.Submit) navigate("/ProjectCheckRecordList"); });
                } else {
                    DialogFn.UnBlockUI();
                    DialogFn.Warning(result.sMessage);
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    const onClearField = () => {
        Object.keys(form.getValues()).forEach((key) => {
            form.setValue(key, null);
            form.clearErrors(key);
        });
        form.setValue("isCommittee", "Y");
        setisStatusPass(null);
        setarrFileDocument([]);
        onClearFile.current();
    };

    return (
        <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
            <Grid item xs={12} md={12} container spacing={2}>
                <Grid item xs={12} md={12} container spacing={1} justifyContent={'center'}>
                    <Typography variant='h6' color={'#225192'}>บันทึกผลมติจากการประชุมพิจารณาข้อเสนอโครงการ</Typography>
                </Grid>
                <Grid item xs={12} md={12} container spacing={1} justifyContent={'center'}>
                    <Typography variant='h6' color={'#354862'}>คณะกรรมการบริหารกองทุนจัดการซากดึกดำบรรพ์</Typography>
                </Grid>
                <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item xs={12} md={1.5}>
                            <Typography variant='body1' fontWeight="bold">ชื่อโครงการ</Typography>
                        </Grid>
                        <Grid item xs={12} md={10.5}>
                            <Typography variant='body1'>{ObjDataProject?.sProjectName}</Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item xs={12} md={1.5}>
                            <Typography variant='body1' fontWeight="bold">หน่วยงาน</Typography>
                        </Grid>
                        <Grid item xs={12} md={10.5}>
                            <Typography variant='body1'>{ObjDataProject?.sUnitTypeName}</Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item xs={12} md={1.5}>
                            <Typography variant='body1' fontWeight="bold">งบประมาณ</Typography>
                        </Grid>
                        <Grid item xs={12} md={10.5} container spacing={1}>
                            <Grid item>
                                <Typography variant='body1'>{formatNumber(ObjDataProject?.nProjectBudget, 2) ?? " - "}</Typography>
                            </Grid>
                            <Grid item>
                                <Typography variant='body1' fontWeight="bold">บาท</Typography>
                            </Grid>
                            <Grid item>
                                <Typography variant='body1'>{"(" + (ObjDataProject?.sBudgetThaiBaht ?? "แสดงวงเงินตัวอักษรภาษาไทย") + ")"}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item xs={12} md={1.5}>
                            <Typography variant='body1' fontWeight="bold">มาตรา</Typography>
                        </Grid>
                        <Grid item xs={12} md={10.5}>
                            <Typography variant='body1'>{ObjDataProject?.sSectionName}</Typography>
                        </Grid>
                    </Grid>
                    {!isFastTrack &&
                        <>
                            <Grid item xs={12} md={12} container spacing={1}>
                                <Grid item xs={12} md={1.5}>
                                    <Typography variant='body1' fontWeight="bold">เฉลี่ยคะแนนที่ได้</Typography>
                                </Grid>
                                <Grid item xs={12} md={10.5}>
                                    <Typography variant='body1'>{formatNumber(ObjDataProject?.nFinalWeightScore, 2) ?? " - "}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={12} container spacing={1}>
                                <Grid item xs={12} md={1.5}>
                                    <Typography variant='body1' fontWeight="bold">ผลการประเมิน</Typography>
                                </Grid>
                                <Grid item xs={12} md={10.5}>
                                    <Typography variant='body1' style={{ color: (ObjDataProject?.isPassCriteriaScore ? 'green' : 'red'), }} >{ObjDataProject?.sStatusFinalScoreName}</Typography>
                                </Grid>
                            </Grid>
                        </>
                    }
                </Grid>
                <Grid item xs={12} md={12}>
                    <Divider variant="fullWidth" style={{ color: "#df950973", border: '2px solid', }} />
                </Grid>
            </Grid>

            <Grid item xs={12} md={12} container spacing={2}>
                <FormProvider {...form}>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item xs={12} md={1.5} container spacing={1}>
                            <Grid item>
                                <Typography variant='body1' fontWeight="bold">มติที่ประชุม</Typography>
                            </Grid>
                            <Grid item>
                                <Typography variant='body1' color={'red'}>*</Typography>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={2.5}>
                            <SelectItem
                                id="nMeetingResolutionID"
                                name="nMeetingResolutionID"
                                options={arrProjectStatusID}
                                label={"มติที่ประชุม"}
                                IsNotShowLabel={true}
                                IsClearable={true}
                                required={true}
                                disabled={!isEdit}
                                onChange={(e) => {
                                    if (e !== null) {
                                        setisStatusPass(e?.value === 11 ? true : false);
                                    } else {
                                        setisStatusPass(null);
                                    }
                                }}
                            />
                        </Grid>
                    </Grid>
                    {isFastTrack &&
                        <Grid item xs={12} md={12} container spacing={1}>
                            {/* <Grid item xs={12} md={1.5} container spacing={1}>
                                <Grid item>
                                    <Typography variant='body1' fontWeight="bold">{ParseHtml("ผลคะแนนรวมที่ได้ <br/>(คิดค่าน้ำหนัก)")}</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant='body1' color={'red'}>*</Typography>
                                </Grid>                        
                            </Grid> */}
                            <Grid item xs={12} md={1.5} container spacing={1}>
                                <Typography variant='body1' fontWeight="bold">{ParseHtml("ผลคะแนนรวมที่ได้ <br/>(คิดค่าน้ำหนัก)")}</Typography>
                            </Grid>
                            <Grid item xs={12} md={1.5}>
                                <InputNumberItem
                                    id={"nProjectScore"}
                                    name={"nProjectScore"}
                                    label={""}
                                    IsComma={true}
                                    IsAllowScientific={false}
                                    type={"Number"}
                                    ShowDigits={2}
                                    maxDigits={2}
                                    maxInteger={3}
                                    max={100}
                                    min={0}
                                    // textAlign='center'
                                    // endAdornment={"%"}
                                    // required={isFastTrack}
                                    required={false}
                                    disabled={!isEdit || !isFastTrack}
                                />
                            </Grid>
                        </Grid>
                    }
                    <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%', }}>
                        <ContentWrapper style={{ border: '0px solid #f1f1f1 !important', marginTop: '3%', borderRadius: '10px', paddingBottom: '1%', padding: '2%' }}>
                            <Grid item xs={12} md={12} container spacing={1}>
                                <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%', }}>
                                    <Grid item xs={12} md={12} container spacing={1} justifyContent={'center'}>
                                        <Typography variant='body1' fontWeight="bold" style={{ fontSize: '16px' }} color={'#763200'}>หนังสือแจ้งผลโครงการขอรับเงินช่วยเหลือหรืออุดหนุนกิจการใดๆ จากกองทุนจัดการซากดึกดำบรรพ์</Typography>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={12} container spacing={2}>
                                    <Grid item xs={12} md={6} container spacing={1}>
                                        <Grid item xs={12} md={6}>
                                            <TextBoxItem
                                                id={"sFundDocNo"}
                                                name={"sFundDocNo"}
                                                type={"text"}
                                                label={"ที่"}
                                                placeholder={"ทส ๐๕๐๒/๑๒๓"}
                                                required={true}
                                                maxLength={25}
                                                disabled={!isEdit}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <DatePickerItem
                                                id={'dFundDoc'}
                                                name={'dFundDoc'}
                                                label={"วันที่"}
                                                fullWidth={true}
                                                required={true}
                                                // maxDate={new Date()}
                                                disabled={!isEdit}
                                                defaultCalendarMonth={moment(new Date())}
                                                IsDisablePortal={true}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} md={12} container spacing={1}>
                                        <Grid item xs={12} md={6}>
                                            <TextBoxItem
                                                id={"sDocTo"}
                                                name={"sDocTo"}
                                                type={"text"}
                                                label={"เรียน"}
                                                placeholder={"อธิการบดีจุฬาลงกรณ์มหาวิทยาลัย"}
                                                required={true}
                                                maxLength={250}
                                                disabled={!isEdit}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} md={12} container spacing={1}>
                                        <Grid item xs={12} md={6}>
                                            <TextBoxItem
                                                id={"sDocRef"}
                                                name={"sDocRef"}
                                                type={"text"}
                                                label={!isExternal ? "ตามหนังสือ" : "อ้างถึง"}
                                                placeholder={"หนังสือจุฬาลงกรณ์มหาวิทยาลัย"}
                                                required={true}
                                                maxLength={250}
                                                disabled={!isEdit}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6} container spacing={1}>
                                            <Grid item xs={12} md={6}>
                                                <TextBoxItem
                                                    id={"sDocNo"}
                                                    name={"sDocNo"}
                                                    type={"text"}
                                                    label={"ที่"}
                                                    placeholder={"อว ๖๔.๑๖/๐๒๐๐๕"}
                                                    required={true}
                                                    maxLength={20}
                                                    disabled={!isEdit}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <DatePickerItem
                                                    id={'dDoc'}
                                                    name={'dDoc'}
                                                    label={"วันที่"}
                                                    fullWidth={true}
                                                    required={true}
                                                    // maxDate={new Date()}
                                                    disabled={!isEdit}
                                                    defaultCalendarMonth={moment(new Date())}
                                                    IsDisablePortal={true}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} md={12} container spacing={1}>
                                        <Grid item xs={12} md={12}>
                                            <TextBoxItem
                                                id={"sDocProjectName"}
                                                name={"sDocProjectName"}
                                                type={"text"}
                                                label={"ชื่อโครงการตามหนังสือ"}
                                                placeholder={"ความหลากหลายทางชีวภาพของซากดึกดำบรรพ์ฟองน้ำและไบรอันโอชัวในแหล่งซากดึกดำบรรพ์บ้านโภชน์ อำเภอหนองไผ่ จังหวัดเพชรบูรณ์"}
                                                required={true}
                                                maxLength={500}
                                                disabled={!isEdit}
                                            />
                                        </Grid>
                                    </Grid>
                                    {(isStatusPass === true && isExternal) && //ผ่าน ภายนอก (ทั้งปกติและเร่งด่วน)
                                        <Grid item xs={12} md={12} container spacing={1}>
                                            <Grid item xs={12} md={12}>
                                                <TextBoxItem
                                                    id={"sBy"}
                                                    name={"sBy"}
                                                    type={"text"}
                                                    label={"โดย"}
                                                    placeholder={"รอง ศาสตราจารย์ ร.ฐาสิณีย์ เจริญฐิติรัตน์ สังกัดภาควิชาธณีวิทยา คณะวิทยาศาสตร์ จุฬลงกรณ์มหาวิยาลัย เป็นหัวหน้าโครงการ"}
                                                    required={(isStatusPass === true && isExternal)}
                                                    maxLength={250}
                                                    disabled={!isEdit}
                                                />
                                            </Grid>
                                        </Grid>
                                    }
                                    <Grid item xs={12} md={12} style={{ paddingTop: '3%', }}>
                                        {/* <Divider variant="fullWidth" style={{ color: "#df950973", border: '1px solid', }} textAlign="left" >ได้รับผลจาก</Divider> */}
                                        <Divider textAlign="left" style={{ color: "#df950973" }}>
                                            <Chip label="ได้รับผลจาก" size="small" style={{ color: "rgb(3 1 100)", fontSize: '15px', backgroundColor: 'rgb(173 181 255 / 26%)', }} />
                                        </Divider>
                                    </Grid>
                                    <Grid item xs={12} md={12} container spacing={1}>
                                        <Grid item xs={12} md={6}>
                                            <CheckBoxItem
                                                id="isCommittee"
                                                name="isCommittee"
                                                options={[{ value: "Y", label: "คณะกรรมการบริหารกองทุนจัดการซากดึกดำบรรพ์" }]}
                                                required={true}
                                                disabled={true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6} container spacing={1}>
                                            <Grid item xs={12} md={6}>
                                                <TextBoxItem
                                                    id={"sMeetingNo"}
                                                    name={"sMeetingNo"}
                                                    type={"text"}
                                                    label={"ประชุมครั้งที่"}
                                                    placeholder={"๕/๒๕๖๖"}
                                                    required={true}
                                                    maxLength={25}
                                                    disabled={!isEdit}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <DatePickerItem
                                                    id={'dMeeting'}
                                                    name={'dMeeting'}
                                                    label={"เมื่อวันที่"}
                                                    fullWidth={true}
                                                    required={true}
                                                    // maxDate={new Date()}
                                                    disabled={!isEdit}
                                                    defaultCalendarMonth={moment(new Date())}
                                                    IsDisablePortal={true}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    {isStatusPass === true && //ผ่าน (ทั้งปกติและเร่งด่วน)
                                        <>
                                            <Grid item xs={12} md={12} container spacing={1}>
                                                <Grid item xs={12} md={!isExternal ? 6 : 3} container spacing={1}>
                                                    <Grid item>
                                                        <Typography variant='body1'>{!isExternal ? "เอกสารการขอเบิกเงินยื่นต่อฝ่ายเลขานุการคณะกรรมการบริหารกองทุนฯ ภายในวันที่" : "ดำเนินการขอเบิกจ่ายเงิน ภายในวันที่"}</Typography>
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography variant='body1' color={'red'}>*</Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <DatePickerItem
                                                        id={'dInvoice'}
                                                        name={'dInvoice'}
                                                        label={"วันที่"}
                                                        fullWidth={true}
                                                        required={isStatusPass === true}
                                                        // maxDate={new Date()}
                                                        disabled={!isEdit}
                                                        defaultCalendarMonth={moment(new Date())}
                                                        IsDisablePortal={true}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} md={12} container spacing={1}>
                                                <Grid item xs={12} md={6}>
                                                    <SelectItem
                                                        id="nCoordinatorID"
                                                        name="nCoordinatorID"
                                                        options={arrDataUserID}
                                                        label={"มอบหมายให้ (ผู้ประสานงาน)"}
                                                        IsClearable={true}
                                                        required={isStatusPass === true}
                                                        disabled={!isEdit}
                                                        onChange={(e) => {
                                                            if (e !== null) form.setValue("sCoordinatorPosition", e?.sValue);
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <TextBoxItem
                                                        id={"sCoordinatorTel"}
                                                        name={"sCoordinatorTel"}
                                                        type={'text'}
                                                        label={"หมายเลขโทรศัพท์"}
                                                        isTelNo={true}
                                                        maxLength={25}
                                                        required={isStatusPass === true}
                                                        pattern={'en-number'}
                                                        disabled={!isEdit}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </>
                                    }
                                    <Grid item xs={12} md={12} container spacing={1}>
                                        <Grid item xs={12} md={12}>
                                            <TextAreaItem
                                                id={"sReason"}
                                                name={"sReason"}
                                                label={"หมายเหตุ/เหตุผล"}
                                                required={isStatusPass === false}
                                                maxLength={1000}
                                                row={3}
                                                disabled={!isEdit}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%', }}>
                                        <Grid item xs={12} md={!isExternal ? 3 : 6} container spacing={1}>
                                            {/* <Grid item>
                                                <Typography variant='body1'>แนบเอกสารประกอบการพิจารณา</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Tooltip placement={'right-end'} title={"สำหรับแนบไฟล์ รายงานการประชุมคณะกรรมการบริหารกองทุนจัดการซากดึกดำบรรพ์"} >
                                                    <ErrorIcon color='primary'/>
                                                </Tooltip>
                                            </Grid>   */}
                                            <Grid item>
                                                <Typography variant='body1'>แนบเอกสารประกอบผลพิจารณา (เพิ่มเติม)</Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <UploadFileItem
                                                required={false}
                                                modeDisplay={"list"}
                                                id={"oFileResultLetter"}
                                                name={"oFileResultLetter"}
                                                label={""} //แนบเอกสารประกอบการพิจารณา                    
                                                arrFile={arrFileDocument}
                                                setarrFile={setarrFileDocument}
                                                // Extension={Extension.ImagePDF}
                                                Extension={["pdf", "jpg", "jpeg", "png"]}
                                                IsFolder={false}
                                                onClearFile={onClearFile}
                                                sFolderTemp="Project"
                                                IsMultiple={true}
                                                nLimitFile={10}
                                                sLimitFile="MB"
                                                sPositionText="right"
                                                IsCrop={true}
                                                cropShape={"retangle"}
                                                cropRatio={16 / 9}
                                                cropResize={true}
                                                cropMovable={true}
                                                disabled={!isEdit}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </ContentWrapper>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%', }}>
                        <Grid item xs={12} md={12}>
                            <UploadFileItem
                                required={false}
                                modeDisplay={"list"}
                                id={"oFileResultLetter_Contract_PDF"}
                                name={"oFileResultLetter_Contract_PDF"}
                                label={"เอกสารสัญญา"}
                                arrFile={arrFileDocumentContractPDF}
                                setarrFile={setarrFileDocumentContractPDF}
                                Extension={["pdf"]}
                                IsFolder={false}
                                onClearFile={onClearFileContractPDF}
                                sFolderTemp="Project"
                                IsMultiple={false}
                                nLimitFile={10}
                                sLimitFile="MB"
                                sPositionText="right"
                                IsCrop={true}
                                cropShape={"retangle"}
                                cropRatio={16 / 9}
                                cropResize={true}
                                cropMovable={true}
                                disabled={!isEdit}
                            />
                        </Grid>
                    </Grid>
                    {(nStatusID >= EnumProjectStatusID.nStatusID_11 && ObjDataFile !== null) ?
                        <Grid item xs={12} md={12} container spacing={1} justifyItems={'center'} alignItems={'center'}>
                            <Grid item>
                                <Typography variant='h6' fontWeight="bold" color={'#221b7c'}>หนังสือแจ้งผลโครงการขอรับเงินช่วยเหลือหรืออุดหนุนกิจการใดๆ จากกองทุนจัดการซากดึกดำบรรพ์</Typography>
                            </Grid>
                            <Grid item>
                                <Tooltip title="PDF">
                                    <IconButton
                                        size="small"
                                        aria-label="close"
                                        onClick={onExampleFilePDF}
                                        data-testid="btnExportPDF"
                                    >
                                        <img src={PDFIcon} alt={"PDF"} style={{ width: 30, height: 35 }} />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>
                        :
                        <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%', }}>
                            <Grid item xs={12} md={12}>
                                <UploadFileItem
                                    required={true}
                                    modeDisplay={"list"}
                                    id={"oFileResultLetter_PDF"}
                                    name={"oFileResultLetter_PDF"}
                                    label={"หนังสือแจ้งผลการพิจารณา"}
                                    arrFile={arrFileDocumentPDF}
                                    setarrFile={setarrFileDocumentPDF}
                                    Extension={["pdf"]}
                                    IsFolder={false}
                                    onClearFile={onClearFilePDF}
                                    sFolderTemp="Project"
                                    IsMultiple={false}
                                    nLimitFile={10}
                                    sLimitFile="MB"
                                    sPositionText="right"
                                    IsCrop={true}
                                    cropShape={"retangle"}
                                    cropRatio={16 / 9}
                                    cropResize={true}
                                    cropMovable={true}
                                    disabled={!isEdit}
                                />
                            </Grid>
                        </Grid>
                    }
                    <Grid item style={{ display: 'none' }}>
                        <BtnSend id="BtnDraft_ResultLetter"
                            onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Draft, EnumProjectStatusID.nStatusID_10, I18n.SetText("Button.DraftResultLetter", I18NextNs.labelComponent)), (err) => {
                                document.getElementById(Object.keys(err)[0])?.focus();
                                if (sTabID !== "Tab5") DialogFn.Warning("กรุณาตรวจสอบข้อมูลในการบันทึกมติให้เรียบร้อย");
                            })}
                        />
                        <BtnSend id="BtnSubmit_ResultLetter"
                            onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Submit, (isStatusPass === true ? EnumProjectStatusID.nStatusID_11 : EnumProjectStatusID.nStatusID_12), I18n.SetText("Button.Confirm", I18NextNs.labelComponent)), (err) => {
                                document.getElementById(Object.keys(err)[0])?.focus();
                                if (sTabID !== "Tab5") DialogFn.Warning("กรุณาตรวจสอบข้อมูลในการบันทึกมติให้เรียบร้อย");
                            })}
                        />
                    </Grid>
                </FormProvider>
            </Grid>
        </Grid>
    )
}
export default ProjectResultLetter;